const BUGSNAG_KEY = process.env.REACT_APP_BUGSNAG_KEY || 'ANY_RANDOM_KEY_TO_PREVENT_CRASH'
const isAdminAccess = window.location.hostname.includes('cms') || process.env.REACT_APP_ACCESS_MODE === 'admin'
export {
  BUGSNAG_KEY,
  isAdminAccess
}
